import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const EllipsisLoader = ({ color = 'white' }) => {
    return (
        <div className="flex items-center justify-center z-50">
            <ThreeDots
                height="20"
                width="45"
                color={color}
                ariaLabel="dots-loading"
            />
        </div>
    );
};

export default EllipsisLoader;
